module.exports = __webpack_public_path__ + "static/media/lg_nimontron.07d332ce.svg";